// extracted by mini-css-extract-plugin
module.exports = {"abrdn-article-footnote":"ArticleFootnote_abrdn-article-footnote__IfovG"};